export const filterOutClientAppointmentsWhichAreReview = () => (clientAppointments) => {
  return clientAppointments.filter(
    (appointment) => !appointment?.appointment_t?.is_new_appointment && !appointment?.appointment
  );
};
